import React, { useEffect } from 'react';
import * as styles from './PaperformEmbed.module.styl';

function PaperformEmbed({
  paperformID = '',
  isRounded = false,
  bgColor = 'transparent',
  paddingTop = '0',
  paddingBottom = '0',
}) {
  useEffect(() => {
    if (!window.Paperform) {
      const script = document.createElement('script');
      script.src = 'https://paperform.co/__embed.min.js';
      document.body.appendChild(script);
    }
  });

  return (
    paperformID && (
      <div
        className={styles.formSectionEmbed}
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          borderRadius: isRounded ? 20 : 0,
          background: bgColor,
          paddingTop,
          paddingBottom,
        }}
        data-paperform-id={paperformID}
      />
    )
  );
}

export default PaperformEmbed;
